"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WideButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
const analytics_1 = require("@streem/analytics");
function WideButton(props) {
    const dataAttrs = {};
    if (props[analytics_1.ANALYTICS_DATA_ATTRIBUTE] !== undefined) {
        dataAttrs[analytics_1.ANALYTICS_DATA_ATTRIBUTE] = props[analytics_1.ANALYTICS_DATA_ATTRIBUTE];
    }
    return ((0, jsx_runtime_1.jsx)(ui_react_1.Row, Object.assign({ width: "75%", justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.Button, Object.assign({ disabled: props.disabled, "data-testid": props.testid, borderRadius: "26px", height: "52px", width: "100%", maxWidth: "350px", onClick: props.onClick }, dataAttrs, { children: (0, jsx_runtime_1.jsxs)(CenteredRow, { children: [props.icon && ((0, jsx_runtime_1.jsxs)(ui_react_1.Row, Object.assign({ mr: 3, justifyContent: "center" }, { children: [(0, jsx_runtime_1.jsx)(ui_react_1.AppIcon, { name: props.icon, size: 'small', color: 'white' }), ' '] }))), (0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ color: "light", headingFontFamily: true, style: { fontSize: '18px' } }, { children: props.children }))] }) })) })));
}
exports.WideButton = WideButton;
const CenteredRow = (0, ui_react_1.styled)(ui_react_1.Row)({
    alignItems: 'center',
    justifyContent: 'center',
});
//# sourceMappingURL=wide_button.js.map